import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
import { TimeZoneStrategyType } from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import getTimeDelayFormatOptions from 'automation-ui-action-features/actions/delay/utils/getTimeDelayFormatOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DelayActionDetail({
  actionMetadata: {
    delay
  },
  messageLangPath = 'actionDetail'
}) {
  const {
    delta,
    timeUnit,
    daysOfWeek,
    timeOfDay,
    optionalTimeZoneStrategy
  } = delay;
  if (timeUnit === ChronoUnit.MONTHS) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.delay.month-unsupported",
      options: {
        count: delta
      }
    });
  }
  const options = getTimeDelayFormatOptions(delay);
  const isUsingObjectTimezone = optionalTimeZoneStrategy && optionalTimeZoneStrategy.type === TimeZoneStrategyType.ENROLLED_OBJECT;
  const getActionDetailContent = () => {
    if (!daysOfWeek.isEmpty() && timeOfDay) {
      return isUsingObjectTimezone ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-detail.content.dayAndTime.inObjectTimezone",
        options: options
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-detail.content.dayAndTime.inStaticTimezone",
        options: options
      });
    } else if (!daysOfWeek.isEmpty()) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-detail.content.dayOfWeek",
        options: options
      });
    } else if (timeOfDay) {
      return isUsingObjectTimezone ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-detail.content.timeOfDay.inObjectTimezone",
        options: options
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-detail.content.timeOfDay.inStaticTimezone",
        options: options
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-detail.content.duration",
        options: options
      });
    }
  };
  const getActionPreviewContent = () => {
    if (!daysOfWeek.isEmpty() && timeOfDay) {
      return isUsingObjectTimezone ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-preview.content.dayAndTime.inObjectTimezone",
        options: options
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-preview.content.dayAndTime.inStaticTimezone",
        options: options
      });
    } else if (!daysOfWeek.isEmpty()) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-preview.content.dayOfWeek",
        options: options
      });
    } else if (timeOfDay) {
      return isUsingObjectTimezone ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-preview.content.timeOfDay.inObjectTimezone",
        options: options
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-preview.content.timeOfDay.inStaticTimezone",
        options: options
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.delay.action-preview.content.duration",
        options: options
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [messageLangPath === 'actionDetail' ? getActionDetailContent() : getActionPreviewContent(), isUsingObjectTimezone ? /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.objectTimeZoneTooltip"
      })
    }) : null]
  });
}
export default DelayActionDetail;